const BASE_URL = 'https://dev01.web-ar.media';

const execute = async (method, url = '', data, headers = {}) => {
    const response = await fetch(`${BASE_URL}${url}`, {
        method,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        ...(data ? { body: JSON.stringify(data) } : {})
    });

    return response.json();
};

const post =  (url, data, headers) => execute('POST', url, data, headers);
const get = (url, data, headers) => execute('GET', url, data, headers);

export {execute, get, post};
